(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dw-discount-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dw-discount-popup')) {
  customElements.define('dw-discount-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.storageKey = 'dw-offer-' + this.dataset.code;
      const remember = () => {
        try { localStorage.setItem(this.storageKey, String(Date.now())); } catch {}
      };
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('close', remember);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      });
      this.querySelector('.dw-offer-apply').addEventListener('click', remember);
      let lastSeen = 0;
      try { lastSeen = Number(localStorage.getItem(this.storageKey)) || 0; } catch {}
      const editor = this.dataset.editor === 'true';
      if (!editor && Date.now() - lastSeen < 7 * 86400000) return;
      this.timer = setTimeout(() => {
        if (this.isConnected && !document.querySelector('dialog[open]')) {
          this.dialog.showModal();
          remember();
        }
      }, editor ? 500 : Number(this.dataset.delay) * 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
